'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _linkWrapper = require('../../link-wrapper');

var _linkWrapper2 = _interopRequireDefault(_linkWrapper);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

var _media = require('../../utils/media');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var render = function render(_ref) {
	var props = _ref.props;
	var blurbUrl = props.blurbUrl,
	    buttonText = props.buttonText,
	    imgSrc = props.imgSrc,
	    showButton = props.showButton,
	    strapline = props.strapline,
	    styleClasses = props.styleClasses,
	    text = props.text,
	    title = props.title;

	var maybeWrapLink = function maybeWrapLink(content) {
		return blurbUrl ? (0, _magicVirtualElement2.default)(
			_linkWrapper2.default,
			{ href: blurbUrl },
			content
		) : content;
	};

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-Blurb02', styleClasses.Blurb], 'data-style-attr': 'Blurb' },
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['CMS-Blurb02-image', styleClasses.Image_Wrapper], 'data-style-attr': 'Image_Wrapper' },
			imgSrc && maybeWrapLink((0, _magicVirtualElement2.default)(_media.Image, { source: imgSrc, 'class': styleClasses.Image, 'data-style-attr': 'Image' }))
		),
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['CMS-Blurb02-content', styleClasses.Content], 'data-style-attr': 'Content' },
			strapline && (0, _magicVirtualElement2.default)(
				'h3',
				{ 'class': styleClasses.Strapline, 'data-style-attr': 'Strapline' },
				maybeWrapLink(strapline)
			),
			title && (0, _magicVirtualElement2.default)(
				'h2',
				{ 'class': styleClasses.Title, 'data-style-attr': 'Title' },
				maybeWrapLink(title)
			),
			text && (0, _magicVirtualElement2.default)(
				'p',
				{ 'class': styleClasses.Text, 'data-style-attr': 'Text' },
				maybeWrapLink(text)
			),
			showButton && (0, _magicVirtualElement2.default)(
				_linkWrapper2.default,
				{ href: blurbUrl, 'class': ['Button', styleClasses.Button], 'data-style-attr': 'Button' },
				buttonText
			)
		)
	), props);
};

exports.default = { render: render };